import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import * as fromMapActions from '../../../store/actions/map.actions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-user-position-center-button',
  standalone: false,
  templateUrl: './user-position-center-button.component.html'
})
export class UserPositionCenterButtonComponent {
  private store = inject(Store);

  centerOnUser() {
    this.store.dispatch(fromMapActions.centerOnUserPosition());
  }
}
